export const spendableProductNames = [
  'Paid Search Advertising',
  'Meta Advertising',
  'Microsoft Advertising',
  'Linkedin Advertising',
  'Snapchat Advertising',
  'TikTok Advertising',
  'Google Display Advertising',
  //   'Programmatic Display Advertising',
  //   'Programmatic Audio Advertising',
  //   'Programmatic Video Advertising',
  'Spotify Advertising',
  'SEO - Tier 1',
  'SEO - Tier 2',
  'SEO - Tier 3',
  'SEO - Tier 4',
]

export const isSpendableProduct = (productName?: string): boolean => {
  return spendableProductNames.includes(productName || '')
}
export const isActiveThisMonth = (start, end) => {
  const today = new Date()
  try {
    const startDate = new Date(start)
    const endDate = new Date(end)
    return startDate <= today && endDate >= today
  } catch {
    return false
  }
}
